module.exports = __webpack_public_path__ + "img/resources.9fc72b09.png";